import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroupFilters } from '../../table-filters/model/table-filter.model';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [ReactiveFormsModule, NgIf, NgFor]
})
export class SelectComponent implements OnInit {
  @Input() filter: FormGroupFilters;
  @Input() form: UntypedFormGroup;
  @Output()
  changeItem = new EventEmitter();

  constructor() { }

  ngOnInit() { }

  change(event) {
    this.changeItem.emit({
      name: this.filter.name,
      value: event.target['value']
    });
  }
}
